import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const opeauthgpMstRepository = RepositoryFactory.get("opeauthgpMst");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setOpeauthgpMst(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadOpeauthgpMst(context, screenId) {
    const list = await opeauthgpMstRepository.list(screenId);
    if (list.status < 300) {
      context.commit("setOpeauthgpMst", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
